import React, { useState, useEffect } from "react";
import { Redirect,useHistory } from "react-router-dom";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from "@material-ui/core/FormLabel";
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import MessageBox from "../../components/MessageBox/MessageBox";
import { get_cookies, isLoggedIn } from "../../components/Cookies/Cookies";
import PopUpModal from "../../components/Modal/PopUpModal";
import numeral from "numeral";

const useStyles = makeStyles((theme) => ({
  title: {
    marginTop: 0,
  },
  field: {
    width: "100%",
    color: "#102027",
    marginBottom:"6px"
  },
  autoComplete: {
    width: "100%",
    marginTop: "0",
    marginBottom: "0.5rem",
  },
  date: {
    width: "100%",
    marginBottom: "1rem",
  },
  buttonContainer: {
    textAlign: "right",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: "600px",
    margin: "0 auto",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "800px",
  },
  button: {
    textAlign: "right",
    marginTop: "30px",
    "& .MuiButton-containedPrimary": {
      marginRight: "10px",
    },
  },

  buttonMarginRight: {
    marginRight: "0.5rem",
  },
}));

const FranchiseInformation = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const packageInfo = props.location.packageInfo || {};
  const navid = props.location.pageInfo ? props.location.pageInfo.navid : "";
  const CurrentPage = props.location.pageInfo
    ? props.location.pageInfo.navname
    : "";
  const TransactionInformation = props.location.transactionInfo
    ? props.location.transactionInfo
    : "";
  // const isCORelease = props.location.isCORelease ? props.location.isCORelease : '';
  //ApiData Component useState SOF
  const [isCORelease, setIsCORelease] = useState([
    props.location.isCORelease ? props.location.isCORelease : "",
  ]);
  const [packages_list, loadPackagesDropdown] = useState([]);
  const [location_dropdown, loadLocationDropdown] = useState([]);
  const [branchIdNo, setBranchIdNo] = useState(get_cookies("branchidno"));
  const [branchCurcode, setBranchCurcode] = useState(get_cookies("curcode"));
  const [nextPagePath, setnextPagePath] = useState("");
  const [isLoaded, setisLoaded] = useState(false);
  const [maxPackageCount, setMaxPackageCount] = useState(
    packageInfo.wholesale_count || 0
  );
  const [defaultLocation, setSelectedWareHouse] = useState({
    id: TransactionInformation.warehouse,
    description: TransactionInformation.warehouse_desc,
  });
  const headers = {
    "Content-Type": "multipart/form-data",
  };

  const goBack = () => {
    history.goBack();  // This will take you to the previous page
  };
  const get_warehouse = () => {
    //get data for warehouse/location dropdown
    // console.log("props", props);
    const formData = new FormData();
    formData.append("form_data", "");
    const apiUrl = process.env.REACT_APP_API_URL + "warehouse";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadLocationDropdown(res.data.warehouse);
    });
  };
  const get_setpackages = () => {
    //get data for warehouse/location dropdown
    const form_data = {
      hqidno: branchIdNo,
      // idno: TransactionInformation.activationcode,
      // navid: navid,
      atype: packageInfo.packagetype,
      country: packageInfo.country,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "wholesale_set_list";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadPackagesDropdown(res.data.packages_list.info);
    });
  };
  const validate_packagecount = () => {
    props.history.push(nextpage);
    //get data for warehouse/location dropdown
    //test query
    //     let url_function = "validate_packagecount";
    //     if (isCORelease == "yes") {
    //       url_function = "validate_packagecount2";
    //     }
    //     const form_data = {
    //       selectedpackages: TABLE_DATA,
    //       navid: navid,
    //     };
    //     const formData = new FormData();
    //     formData.append("form_data", JSON.stringify(form_data));
    //     const apiUrl = process.env.REACT_APP_API_URL + url_function;
    //     axios.post(apiUrl, formData, { headers: headers }).then((res) => {
    //       if (res.data.result.success == 1) {
    //         if (isCORelease == "") {
    //           props.history.push(nextpage);
    //         } else {
    //           props.history.push(nextpageEncoding);
    //         }
    //       } else {
    //         setShowMsgBox(true);
    //         setMsg(res.data.result.message);
    //         setMsgType("warning");
    //         setTimeout(() => {
    //           setShowMsgBox(false);
    //         }, 3000);
    //       }
    //     });
  };
  let api_url = "getpackagecountbinary";

  // const get_package_count = async () => {
  //   await axios
  //     .get(process.env.REACT_APP_API_URL + api_url, {
  //       params: {
  //               hqidno:branchIdNo,
  //               curcode:get_cookies('curcode'),

  //         navid: navid,
  //       },
  //     })
  //     .then((res) => {
  //       console.log(res.data.data.wholesale_count)
  //       setMaxPackageCount(res.data.data.wholesale_count);
  //     })
  //     .catch((error) => {
  //       // setMaxPackageCount(1);
  //       // console.log(error.message);
  //     });
  // };
  const check_if_have_item = () => {
    const apiUrl = process.env.REACT_APP_API_URL + "does_have_item";
    const form_data = {
      navid: navid,
      curcode: branchCurcode,
    };
    const formData = new FormData();
    const itemNextPage = {
      // pathname: "/package-sales-payment",
      pathname: "/Franchise-payment",
      transactionInfo: TransactionInformation, // your data array of objects
      selectedpackagesInfo: TABLE_DATA,
      packageInfo: packageInfo,
      pageInfo: {
        navid: navid,
        navname: CurrentPage,
      },
    };
    props.history.push(itemNextPage);
    //     formData.append("form_data", JSON.stringify(form_data));
    //     axios.post(apiUrl, formData, { headers: headers }).then((res) => {
    //       if (res.data.success == 1) {
    //         if (res.data.noofpackages > 0) {
    //           setnextPagePath(res.data.nextpagepath);
    //         } else {
    //           const itemNextPage = {
    //             // pathname: "/package-sales-payment",
    //             pathname: "/package-sales-payment",
    //             transactionInfo: TransactionInformation, // your data array of objects
    //             selectedpackagesInfo: TABLE_DATA,
    //             pageInfo: {
    //               navid: navid,
    //               navname: CurrentPage,
    //             },
    //           };
    //           props.history.push(itemNextPage);
    //         }
    //       } else {
    //         setShowMsgBox(true);
    //         setMsg("Missing navigation ID");
    //         setMsgType("warning");
    //         setTimeout(() => {
    //           setShowMsgBox(false);
    //         }, 3000);
    //       }
    //     });
  };
  //ApiData Component useState EOF

  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  //Message Box EOF

  //Table Settings
  const [TABLE_DATA, setSelectedPackageTable] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [messageType, setMessageType] = useState("info");
  const [popUpMessage, setPopUpMessage] = useState("");

  const onSelectPackage = () => {
    const newData = [...TABLE_DATA];
    let totalEnteredQty = selectedPackage.packageqty;
    if (newData != "") {
      totalEnteredQty =
        parseInt(newData.length) + parseInt(selectedPackage.packageqty);
    }
    const neededKeys = ["packageid", "packagename", "packageqty"];
    if (neededKeys.every((key) => Object.keys(selectedPackage).includes(key))) {
      if (
        totalEnteredQty > maxPackageCount ||
        selectedPackage.packageqty == "" ||
        selectedPackage.packageqty == null
      ) {
        setPopUpMessage("You exceed the maximum number of the set included");
        setModalOpen(true);
        setMessageType("warning");
        // setShowMsgBox(true);
        // setMsg("You exceed the maximum number of the packages included");
        // setMsgType("warning");
        setTimeout(() => {
          setModalOpen(false);
        }, 3000);
      } else {
        if (
          selectedPackage.packageqty <= 0 ||
          selectedPackage.packageqty == "" ||
          selectedPackage.packageqty == null
        ) {
          setPopUpMessage("Please select atleast 1 set");
          setModalOpen(true);
          setMessageType("warning");
          // setShowMsgBox(true);
          // setMsg("Please select atleast 1 package");
          // setMsgType("warning");
          setTimeout(() => {
            setModalOpen(false);
          }, 3000);
        } else {
          for (let i = 0; i < selectedPackage.packageqty; i++) {
            const tempObj = {
              packageid: selectedPackage.packageid,
              packagename: selectedPackage.packagename,
            };
            newData.push(tempObj);
          }
        }
      }
    } else {
      setShowMsgBox(true);
      setMsg("Please select atleast 1 2");
      setMsgType("warning");
      setTimeout(() => {
        setShowMsgBox(false);
      }, 3000);
    }
    setSelectedPackageTable([...newData]);
    setSelectedPackage({});
    handleClose();
  };

  const onPackageSelectionChange = (event) => {
    const newData = { ...selectedPackage };
    newData[event.target.name] = event.target.value;
    setSelectedPackage({ ...newData });
  };
  const refreshTable = () => {
    const newData = [...TABLE_DATA];
    setSelectedPackageTable([...newData]);
  };

  const TABLE_COLUMNS = [
    {
      name: "packageid",
      label: "ID",
    },
    {
      name: "packagename",
      label: "Name",
    },
    {
      name: "Delete",
      label: "Action",
      options: {
        filter: true,
        sort: false,
        empty: true,
        customBodyRender: (rowIndex, dataIndex) => {
          return (
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => {
                updateSelectedPackages(dataIndex.rowIndex);
              }}
            >
              Delete
            </Button>
          );
        },
      },
    },
  ];

  const TABLE_OPTION = {
    filterType: "checkbox",
    selectableRows: "single",
    selectableRowsHideCheckboxes: true,
    selectableRowsOnClick: false,
    print: false,
    filter: false,
    download: false,
    viewColumns: false,
    onRowsDelete: (data) => {
      updateSelectedPackages(data.data[0].dataIndex);
    },
  };

  const updateSelectedPackages = (index) => {
    TABLE_DATA.splice(index, 1);
    refreshTable();
  };

  const selectLocationProps = {
    options: location_dropdown,
    getOptionLabel: (option) => option.description,
  };
  //Table Settings EOF
  const NumberKeyTrapper = (e) => {
    var a = [];
    var k = e.which;

    for (let i = 48; i < 58; i++) {
      a.push(i);
    }

    if (!(a.indexOf(k) >= 0)) {
      e.preventDefault();
    }
  };

  //Modal Settings
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedPackage("");
  };
  //Modal Settings EOF

  //OnLoad Event/Data Fetching SOF
  useEffect(() => {
    // console.log("props", props);
    isLoggedIn();
    setisLoaded(false);
    //     check_if_have_item();
    get_warehouse();
    get_setpackages();
    // get_package_count();
    setisLoaded(true);
  }, []);
  //OnLoad Event/Data Fetching SOF

  //Api Functions SOF
  // Code blocks here
  //Api Request Functions EOF

  // useEffect(() => {
  //   console.log('223',packages_list)

  // }, [])

  const dropDownPackages = {
    options: packages_list,
    getOptionLabel: (option) => option.description,
  };
  //FormData
  const [prep_data, setData] = useState({});
  //FormData EOF
  const nextpage = {
    // pathname: "/package-sales-payment",
    pathname: "/Franchise-franchise",
    transactionInfo: TransactionInformation, // your data array of objects
    selectedpackagesInfo: TABLE_DATA,
    packageInfo: packageInfo,
    pageInfo: {
      navid: navid,
      navname: CurrentPage,
    },
  };

  //   const nextpageEncoding = {
  //     pathname: "/package-sales-packagesitem",
  //     transactionInfo: TransactionInformation, // your data array of objects
  //     selectedpackagesInfo: TABLE_DATA,
  //     pageInfo: {
  //       navid: navid,
  //       navname: CurrentPage,
  //     },
  //   };
  return (
    <div className="page">
      <PopUpModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        message={popUpMessage}
        type={messageType}
      />
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        {/* {console.log("count", maxPackageCount)} */}
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink to="/wholesale">
            <h2 className="header-title">Franchise Set</h2>
          </NavLink>

          <span 
           onClick={goBack} style={{color:'#339933'}}>
            <h2 className="header-title">{props.location.packageInfo.packagetype} - {props.location.packageInfo.packagetypename}</h2>
              </span>


          <Typography color="textPrimary">Franchise Set Information</Typography>
        </Breadcrumbs>
      </div>
      <div className="page-container">
        <form noValidate autoComplete="off">
          <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
          <Grid
            container
            spacing={2}
            alignItems="center"
            justify="center"
            className={classes.root}
          >
            {/* <Grid item xs={12} sm={12} md={12}>
              <Card>
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={4}>
                      <Typography variant="h6">
                        Wholesaler Information
                      </Typography>
                      <Typography>
                        <span style={{ fontWeight: 500 }}>First Name:</span>{" "}
                        {TransactionInformation.fname}
                      </Typography>
                      <Typography>
                        Middle Name: {TransactionInformation.mname}
                      </Typography>
                      <Typography>
                        Last Name: {TransactionInformation.lname}
                      </Typography>
                      <Typography>
                        Date of Birth: {TransactionInformation.dob}
                      </Typography>
                      <Typography>
                        Email: {TransactionInformation.email}
                      </Typography>
                      <Typography>
                        Contact Number: {TransactionInformation.conno}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="h6">Transaction Details</Typography>
                      <Typography>
                        Transaction Date: {TransactionInformation.trandate}
                      </Typography>
                      <Typography>
                        Reference Code: {TransactionInformation.refcode}
                      </Typography>
                      <Typography>
                        Activation Code: {TransactionInformation.activationcode}
                      </Typography>
                      <Typography>
                        Location: {TransactionInformation.warehouse_desc}
                      </Typography>
                      <Typography>
                        Shipping Type: {TransactionInformation.shipping_desc}
                      </Typography>
                      <Typography>
                        Shipping Charge: {TransactionInformation.shippingcharge}
                      </Typography>
                      <Typography>
                        Primary Team: {TransactionInformation.primaryteam_desc}
                      </Typography>
                      <Typography>
                        Secondary Team:{" "}
                        {TransactionInformation.secondaryteam_desc}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="h6">
                        Wholesale Set Information
                      </Typography>
                      <Typography>
                        Set Type: {props.location.packageInfo.package_type}
                      </Typography>
                      <Typography>
                        Set Name: {props.location.packageInfo.package_name}
                      </Typography>
                      <Typography>
                        Set Count: {props.location.packageInfo.package_count}
                      </Typography>
                      <Typography>
                        Set Price: {props.location.packageInfo.package_price}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid> */}
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={4}>
                      <h4 className={classes.title}>Wholesaler Information</h4>
                      <TextField
                        label="First Name"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.fname}
                      />
                      <TextField
                        label="Middle Name"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.mname}
                      />

                      <TextField
                        label="Last Name"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.lname}
                      />

                      <TextField
                        label="Date of birth"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.dob}
                      />
                      <TextField
                        label="Email"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.email}
                      />
                      <TextField
                        label="Contact Number"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.conno}
                      />
                                            <TextField
                        label="Sponsor ID No."
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.sponsor_id}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <h4 className={classes.title}>Transaction Information</h4>
                      <TextField
                        label="Transaction Date"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.trandate}
                      />
                      <TextField
                        label="Activation Code"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.activationcode}
                      />

                      <TextField
                        label="Reference Code"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.refcode}
                      />

                      <TextField
                        label="Primary Team"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.primaryteam_desc}
                      />
                      <TextField
                        label="Secondary Team"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.secondaryteam_desc}
                      />
                      <TextField
                        label="Location"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.warehouse_desc}
                      />
                      <TextField
                        label="Shipping Type"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.shipping_desc}
                      />
                      <TextField
                        label="Shipping Charge"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={TransactionInformation.shippingcharge}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <h4 className={classes.title}>
                        Wholesale Set Information
                      </h4>
                      <TextField
                        label="Account Type"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={props.location.packageInfo.packagetype}
                      />
                      <TextField
                        label="Acount Type Name"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={props.location.packageInfo.packagetypename}
                      />



                      <TextField
                        label="Wholesale Set Price"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={numeral(props.location.packageInfo.franchise_price).format("0,0.00")}
                      />
                                            <TextField
                        label="Maximum Set Count"
                        variant="standard"
                        type="text"
                        disabled
                        InputProps={{
                          style: { color: "#102027" },
                          disabled: true,
                        }}
                        className={classes.field}
                        defaultValue={props.location.packageInfo.wholesale_count}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs="12" className={classes.buttonContainer}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpen}
                className={classes.buttonMarginRight}
              >
                Add Set
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <MUIDataTable
                    title={
                      <div>
                        <div className="table-title">Selected Set</div>
                      </div>
                    }
                    id="table-grid"
                    data={TABLE_DATA}
                    columns={TABLE_COLUMNS}
                    options={TABLE_OPTION}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs="12" className={classes.buttonContainer}>
              <Button
                variant="contained"
                color="primary"
                onClick={validate_packagecount}
              >
                Next
              </Button>
            </Grid>
          </Grid>
          <div>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={open}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open}>
                <div className={classes.paper}>
                  <h2 id="transition-modal-title">Add Set</h2>
                  <form action="" className={classes.root}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid
                        item
                        xs={3}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Typography>{"Set"}</Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Autocomplete
                          {...dropDownPackages}
                          autoComplete
                          includeInputInList
                          className={classes.autoComplete}
                          name="packagename"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              margin="normal"
                              label="Name"
                              variant="outlined"
                              required="true"
                            />
                          )}
                          onChange={(event, newValue) => {
                            if (!newValue == "" || !newValue == null) {
                              const newData = { ...selectedPackage };
                              newData["packageid"] = newValue.id;
                              newData["packagename"] = newValue.description;
                              setSelectedPackage({ ...newData });
                            } else {
                              setSelectedPackage("");
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <Typography>{"Quantity"}</Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <TextField
                          type="number"
                          required
                          name="packageqty"
                          label="Quantity"
                          variant="outlined"
                          style={{ width: "30%" }}
                          inputProps={{ min: 0, max: 10000 }}
                          onKeyPress={NumberKeyTrapper}
                          onChange={onPackageSelectionChange}
                        />
                      </Grid>
                    </Grid>
                    <div className={classes.button}>
                      <Button
                        variant="contained"
                        onClick={handleClose}
                        className={classes.buttonMarginRight}
                      >
                        Close
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={onSelectPackage}
                      >
                        Add
                      </Button>
                    </div>
                  </form>
                </div>
              </Fade>
            </Modal>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FranchiseInformation;
